export const PRESET_GIFT_CARD_VALUES = [
  { label: '$50', value: '5000' },
  { label: '$75', value: '7500' },
  { label: '$100', value: '10000' },
  { label: '$200', value: '20000' },
  { label: 'Custom', value: '0' },
];

export const GIFT_CARD_RECIPIENT_VALUES: {
  label: string;
  value: 'self' | 'other';
}[] = [
  { label: 'Someone else', value: 'other' },
  { label: 'Myself', value: 'self' },
];
